import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Constants } from "../constants";

declare var $: any;
declare var Nanobar: any;
@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.css']
})
export class RatingsComponent implements OnInit {
  priceIconForDouble: string = Constants.iconForDoublePrice;
  serviceCityIdForOrders: any;
  serviceCity: any;
  businessDetailforOrder: any;
  searchBusinessDetailforOrder: any;
  businessForOrders = 'Business';
  dispensary_id: any;
  last_pageOrder: any;
  OrderData: any;
  limitOrders: any;
  city_id: any;
  last_page: any;
  outletId: any;
  city: any;
  filterRatingg:any = 'Filter - Rating'
  selectionDayOpenTime: any;
  outletDayindex: any;
  selectionDayCloseTime: any;
  pageOrder: any;
  orderId: any;
  Paginationdisable: boolean;
  serviceCityForOrders: any = 'Services - All';
  constructor(private dataService: DataService) { }
  servicesDatas: any;
  ratingData: any;
  serviceName = 'Services - All';
  page: any;
  version_number: any;
  btnShowAfterDataLoad = false;
  paginatedData: any;
  searchOrderString: any;
  servicedetail: any;
  pageLoad: any;
  dispensaryDetails: any;
  limit: any;
  Rating_number :any;
  orderDetailToReopenOpId: any;
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  dineIn: any;
  tableNo: any;
  pickUp: any;
  pickupAddress: any;
  productData: any;
  thirdPartyData: any;
  onDetailDriverData: any;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  orderCreated: any;
  orderBooked: any;
  deliverStartDate: any;
  deliverEndDate: any;
  nao = new Nanobar();


  getRatingData() {
    //this.defaultViewToShow = false;
    this.btnShowAfterDataLoad = false;
    this.limit = 20;
    this.page = 0;
    this.dataService.getBusinessRating(window.localStorage.getItem('token'), this.searchOrderString, this.dispensary_id, this.city_id, this.limit, this.page,this.Rating_number).subscribe(
      (data) => {
        this.nao.go(100);
        this.ratingData = data;
        this.last_page = this.ratingData.last_page;
        this.last_pageOrder = this.ratingData.last_page;
        this.ratingData = this.ratingData.items;
        this.btnShowAfterDataLoad = true;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  filterRating(Rating_no, type = "", random = "")
  {
    this.Rating_number = Rating_no;
    if (this.Rating_number == -1) {
      this.filterRatingg = 'All Rating';
    }
    if (this.Rating_number == 1) {
      this.filterRatingg = '1 Star Rating';

    }
    if (this.Rating_number == 2) {
      this.filterRatingg = '2 Star Rating';

    }
    if (this.Rating_number == 3) {
      this.filterRatingg = '3 Star Rating';

    }
    if (this.Rating_number == 4) {
      this.filterRatingg = '4 Star Rating';

    }
    if (this.Rating_number == 5) {
      this.filterRatingg = '5 Star Rating';
    }
    console.log('orderid',Rating_no);
    this.getRatingData();
  }
  filterServiceId(city, service = '', random = '') {
    this.businessForOrders = 'Business';
    this.pageLoad = 0;
    console.log('cityfilter', city);

    this.serviceName = city;
    this.city_id = city;

    if (this.serviceName == 'All') {

      this.serviceName = 'Services - All';
    }
    if (this.serviceName != 'Services - All') {
      this.city_id = city;
    }
    else if (this.serviceName == 'Services - All') {
      this.city_id = '-1';
    }
    this.serviceCityForOrders = city;

    this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.city_id, '').subscribe(
      (data) => {
        this.nao.go(100);
        this.servicedetail = data;
        console.log('Cities', this.servicedetail);
        // this.page++;
        // this.servicedetail = this.servicesDatas.city_list;

        // this.businessName = 'Business - ' + city
        this.dispensaryDetails = data;
        this.getRatingData();
        //this.filterBusinessId(-1, name, '');
        //this.orderslist(this.status);
        this.businessForOrders = 'Business';



      },
      (error) => {
        this.nao.go(100);
        console.log('error', error)
      }
    );
  }

  findcustomerDetail(cust_id){}
  // getRatingData() {
  //   //this.defaultViewToShow = false;
  //   this.btnShowAfterDataLoad = false;
  //   this.limit = 20;
  //   this.page=0;
  //   this.dataService.getBusinessRating(window.localStorage.getItem('token'),this.searchOrderString,this.dispensary_id,this.city_id,this.limit,this.page).subscribe(
  //     (data) => {
  //       //this.nao.go(100);
  //       this.ratingData = data;
  //       this.last_page = this.ratingData.last_page;
  //       this.last_pageOrder= this.ratingData.last_page;
  //       this.ratingData = this.ratingData.items;
  //       this.btnShowAfterDataLoad = true;
  //     },
  //     (error) => {
  //       //this.nao.go(100);
  //       console.log('error', error);
  //     }
  //   );
  // }
  getServices() {

    this.dataService.getservices(localStorage.getItem('token')).subscribe(
      (data) => {
        this.servicesDatas = data;
        this.servicesDatas = this.servicesDatas.city_list;


      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
        // toastr.error('Some thing went wrong');
      }
    );
  }
  businessIdForOrders: any;
  createOrder(id, name) {

    this.businessIdForOrders = id;
    this.businessForOrders = name;
  }
  businessName = 'Business - All';
  getDispensaryListing() {
    // console.log('e');
    this.dataService.getdispensaryListing(localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.dispensaryDetails = data;
        this.businessName = "Business - All";
        //this.orderslist(this.status);
        this.servicedetail = data;
        console.log(this.servicedetail);

      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
        //ßtoastr.error('Some thing went wrong');
      }
    );
  }
  filterBusinessId(id, name, detail) {

    this.dispensary_id = id;
    //this.businessForOrders = name;
    if (this.dispensary_id == -1) {
      this.businessName = 'All Businesses';
    }

    if (this.dispensary_id != -1) {
      this.businessName = name;

    }
    this.businessForOrders = name;
    console.log('dispansaryid', id);
    this.getRatingData();
  }
  //this.outlets();
  //this.outletId = -1;
  //this.orderslist(this.status);


  // this.dataService.getoutletsListOfBusiness(localStorage.getItem('token'), this.dispensaryId).subscribe(
  //   (data) => {
  //     // this.nao.go(100);
  //     this.servicedetail = data;
  //     // this.businessName = this.servicedetail.dispensary_name;
  //
  //
  //   },
  //   (error) => {
  //     // this.nao.go(100);
  //     console.log('error', error);
  //     toastr.error('Some thing went wrong');
  //   } ̰ ̰
  // );


  getOrderServices() {

    {
      this.dataService.getordersList(window.localStorage.getItem('token'), status, this.limitOrders, this.city_id, this.dispensary_id, this.outletId, this.outletDayindex, this.selectionDayOpenTime, this.selectionDayCloseTime, this.pageOrder, this.orderId).subscribe(
        (data) => {
          this.nao.go(100);
          //  if(this.OrderData[this.order_Type] == this.orderid)
          //  {
          this.OrderData = data;
          console.log('data', this.OrderData);
          //this.orderslist(this.status);
          //this.servicedetail = data;
          console.log('hello');



        },
        (error) => {
          this.nao.go(100);
          console.log('error', error);
          //toastr.error('Some thing went wrong');
        }
      );

    }

  }

  getBusinessRatingByPageFunction() {
    //this.nao.go(30);
    this.Paginationdisable = true;

    //this.btnShowAfterDataLoad=false;
    this.page++;
    this.limit = 20;
    console.log('login data');
    this.dataService.getBusinessRatingByPage(window.localStorage.getItem('token'), this.searchOrderString, this.dispensary_id, this.city, this.page, this.limit).subscribe(
      (data) => {
        //this.nao.go(100);
        this.paginatedData = data;
        // this.limit = this.paginatedData.limit;
        this.last_page = this.paginatedData.last_page;
        this.paginatedData = this.paginatedData.items;
        this.Paginationdisable = false;
        for (var i = 0; i < this.paginatedData.length; i++) {
          this.ratingData.push(this.paginatedData[i]);
        }
      },
      (error) => {
        //this.nao.go(100);
        console.log('error', error);
      });

  }
  searchAllOrders() {
    //clearTimeout(this.searchTimeOut);
    this.btnShowAfterDataLoad = false;
    this.page = 0;
    this.limit = 20;
    this.dataService.getBusinessRating(window.localStorage.getItem('token'), this.searchOrderString, this.dispensary_id, this.city_id, this.limit, this.page,this.Rating_number).subscribe(
      (data) => {
        this.nao.go(100);
        this.ratingData = data;
        this.last_page = this.ratingData.last_page;
        this.last_pageOrder = this.ratingData.last_page;
        this.ratingData = this.ratingData.items;
        this.btnShowAfterDataLoad = true;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  clearSearch() {

    this.pageOrder = 0;
    this.searchOrderString = '';
    this.searchAllOrders();
  }
  // Getting order detail //

  orderDetailCall(id) {

    this.orderDetailToReopenOpId = id;
    this.dataService.getOrderhDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.orderDetailData = data;

        console.log('orderdetailcall', this.orderDetailData);

        this.customerDetail = this.orderDetailData.customer_detail;
        this.droppOffAddress = this.orderDetailData.dropoff_address;
        // we have to work here
        this.userDropDocs = this.orderDetailData.drop_off_docs;
        console.log('userDropDocs', this.userDropDocs);
        this.orderDataDisplay = this.orderDetailData.order;
        let order_type = this.orderDataDisplay.delivery_man_type;
        if (order_type === 4) {
          this.dineIn = true;
          this.tableNo = this.orderDataDisplay.dine_in_table_number;
        } else {
          this.dineIn = false;
          this.tableNo = '';
        }
        if (order_type === 5) {
          this.pickUp = true;
        } else {
          this.pickUp = false;
        }
        this.pickupAddress = this.orderDetailData.pickup_address;
        this.productData = this.orderDetailData.product;
        this.thirdPartyData = this.orderDetailData.third_party;
        this.onDetailDriverData = this.orderDetailData.driver;
        this.returnOrderItems = this.orderDataDisplay.return_items['return_product_list'];
        this.returnOrderItemsLength = this.returnOrderItems.length;
        this.orderCreated = this.orderDetailData.order_created_by;
        this.orderBooked = this.orderDetailData.order_booked_by;
        // console.log('this.orderCreated', this.orderCreated);
        console.log('this.onDetailDriverData', this.onDetailDriverData);
        $('#orderDetailPop').modal('show');

        var cDate = new Date().getDate();
        var cYear = new Date().getFullYear();
        var cMonth = new Date().getUTCMonth() + 1;
        var openTime = this.orderDataDisplay.open_time;
        var tOpen = cYear + '/' + cMonth + '/' + cDate + ' ' + openTime + ' ' + 'UTC';
        var dateObjOpen = new Date(tOpen);
        this.deliverStartDate = dateObjOpen;

        var closeTime = this.orderDataDisplay.close_time;
        var tClose = cYear + '/' + cMonth + '/' + cDate + ' ' + closeTime + ' ' + 'UTC';
        var dateObjClose = new Date(tClose);
        this.deliverEndDate = dateObjClose;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }


  ngOnInit() {

    this.getServices();
    this.getOrderServices();
    this.getRatingData();
    // this.getBusinessRatingByPageFunction();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#ratings').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/app/ratings/ratings.component.ts